// modules/SiteDownloadButton.js
import React        from 'react';
import Arrow from '../images/arrow';
import renderHTML    from 'react-render-html';

class SiteDownloadButton extends React.Component {
	render() {

		if (this.props.buttonlink) {
			var d = new Date();
			var link = this.props.buttonlink + "?ts=" + d.getTime();
			return (
				<a href={link} target="_blank" className="pdfbutton">
					<div className="site-downloads-button">
						<Arrow/>
						<div className="site-downloads-titles">
							{renderHTML(this.props.children)}
						</div>
					</div>
				</a>
			)
		} else {
			return null;
		}
	}
}

export default SiteDownloadButton;


/** WEBPACK FOOTER **
 ** ./src/modules/common/SiteDownloadButton.js
 **/